/* global axios */
import ApiClient from './ApiClient';

class AccountAPI extends ApiClient {
  constructor() {
    super('', { accountScoped: true });
  }

  createAccount(data) {
    return axios.post(`${this.apiVersion}/accounts`, data);
  }

  async getCacheKeys() {
    const response = await axios.get(
      `/api/v1/accounts/${this.accountIdFromRoute}/cache_keys`
    );
    return response.data.cache_keys;
  }

  updateWithAvatar(accountId, { avatar, ...params }) {
    const formData = new FormData();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined) formData.append(key, params[key]);
    });
    if (avatar) formData.append('avatar', avatar);
    return axios.put(`${this.apiVersion}/accounts/${accountId}`, formData);
  }

  deleteAvatar(accountId) {
    return axios.delete(
      `${this.apiVersion}/accounts/${accountId}/avatar`
    );
  }
}

export default new AccountAPI();
